import { Button, Modal, Switch, Table, TableProps, Typography, Image } from "antd";
import { EMPTY_VALUE } from "constant";
import { IDetailChangeRevisionOutputModel } from "interfaces";
import { useState } from "react";
import { OtherUtil } from "utils/other";
const Diff = require("diff");

export interface IHistoryTablePostFormProps {
  data: IDetailChangeRevisionOutputModel[];
  onClose: () => void;
}

export default function HistoryTablePostForm(props: IHistoryTablePostFormProps) {
  const [html, setHtml] = useState<{ text1: string; text2: string } | null>(null);

  const renderDiffHtml = () => {
    if (!html) return <></>;
    const obj: any = {};

    const decodedText1 = OtherUtil.convertToText(html?.text1);
    const decodedText2 = OtherUtil.convertToText(html?.text2);
    const diff = Diff.diffLines(decodedText1, decodedText2);

    const diffElement = diff.map((part: any, index: number) => {
      const isChange = part.added && part.removed;
      const color = part.added ? "#b7eb8f" : part.removed ? "#ffa39e" : "transparent";
      const isImage = OtherUtil.isImageUrl(part?.value);

      if (isImage && isChange) {
        const src = part?.value.replace("[", "").replace("]", "");

        const originImg = OtherUtil.getBaseUrl(src);

        if (!obj[originImg]) {
          obj[originImg] = true;
          return (
            <div>
              <img src={src} alt="src" style={{ width: "50%" }} />
            </div>
          );
        }
        return <></>;
      }

      return (
        <div>
          <Typography.Text
            key={index}
            // className={part.added ? "bg-green-100 text-green-800" : part.removed ? "bg-red-100 text-red-800" : ""}
            style={{ backgroundColor: color }}
          >
            {part.value}
          </Typography.Text>
        </div>
      );
    });

    return (
      <Modal
        title="Thay đổi"
        open={!!html}
        width={"100%"}
        onClose={() => setHtml(null)}
        onCancel={() => setHtml(null)}
        footer={false}
      >
        {diffElement}
      </Modal>
    );
  };

  const renderContentColumns = (data: IDetailChangeRevisionOutputModel, column: "current" | "update") => {
    if (data.type === "BOOLEAN") {
      return <Switch defaultChecked={data[column] as boolean} disabled />;
    }
    if (data.type === "STRING") {
      return <span>{data[column] || EMPTY_VALUE}</span>;
    }
    if (data.type === "IMAGE") {
      return <Image width={250} src={data[column] as string} />;
    }
    if (data.type === "CONTENT") {
      return (
        <div className="d-flex items-center justify-center w_100">
          <Button
            size="middle"
            variant="filled"
            className="btn btn-outline mr_1"
            onClick={() => {
              setHtml({ text1: data.current as string, text2: data.update as string });
            }}
          >
            Xem chi tiết
          </Button>
        </div>
      );
    }
    return <span>{EMPTY_VALUE}</span>;
  };

  const columns: TableProps<IDetailChangeRevisionOutputModel>["columns"] = [
    {
      title: "Trường dữ liệu",
      dataIndex: "label",
      key: "label",
      width: 200,
    },
    {
      title: "Thay đổi",
      dataIndex: "current",
      key: "current",
      width: "40%",
      render: (_, data) => renderContentColumns(data, "current"),
      onCell: (data) => {
        if (data.type === "CONTENT") return { colSpan: 0 };
        return {};
      },
    },
    {
      title: "Hiện tại",
      dataIndex: "update",
      key: "update",
      width: "40%",
      render: (_, data) => renderContentColumns(data, "update"),
      onCell: (data) => ({
        colSpan: data.type === "CONTENT" ? 2 : 1,
      }),
    },
  ];

  return (
    <>
      {renderDiffHtml()}

      <Modal
        title="Version history"
        open={!!props.data?.length}
        width={"100%"}
        height={"100%"}
        onClose={props.onClose}
        onCancel={props.onClose}
        footer={false}
      >
        {/* {renderDiff2()} */}

        <Table
          className="mt_3 mb_3"
          bordered
          dataSource={props.data}
          columns={columns}
          size={"large"}
          pagination={false}
        />
      </Modal>
    </>
  );
}
